import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { MaskLines } from "@/components/Reveal";
import HeroVisual from "@/components/story/HeroVisual";
import { WRAP } from "@/components/story/layout";

/**
 * Moment 1: complexity becoming clarity.
 *
 * Text takes 7 of 12 columns so the headline can run at 82px without the first
 * line wrapping. Lines are broken where they were written, not where the
 * column happens to end, which is the whole point of a short measure.
 *
 * The headline still leads with AI and still names the buyer: the vaguer
 * "digital systems" framing tested worse (CLAUDE.md). Primary CTA stays the
 * 15-minute call.
 */
export default function HeroStory() {
  return (
    <section
      className="border-b border-ink min-h-[calc(100svh-72px)] flex items-center"
      data-testid="hero"
    >
      <div className={`${WRAP} w-full py-16 md:py-20`}>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 items-center">
          <div className="lg:col-span-7">
            <p className="eyebrow">AUT labs / AI automation, Mumbai</p>

            <h1 className="display story-h1 mt-5">
              <MaskLines
                trigger="mount"
                lines={["AI and automation", "for the work nobody", "should do by hand."]}
              />
            </h1>

            <p className="mt-7 max-w-[40ch] story-lead text-ink/80">
              You explain the business. We find the work worth automating, build it,
              and hand you something that runs.
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-x-7 gap-y-4">
              <Link to="/book" className="pill pill-cobalt group" data-testid="hero-book-btn">
                Book a 15-minute call
                <ArrowRight size={16} className="cta-arrow" aria-hidden="true" />
              </Link>
              <Link
                to="/find-opportunities"
                className="ember-link text-ember-deep py-2"
                data-testid="hero-find-btn"
              >
                See your opportunities first, free →
              </Link>
            </div>

            <p className="mt-7 text-[14px] text-ink/70">
              Free. No technical brief needed. On site in Mumbai when it helps.
            </p>
          </div>

          <div className="lg:col-span-5">
            <HeroVisual />
          </div>
        </div>
      </div>
    </section>
  );
}
